import React from 'react'
import Navbar from '../../Components/Navbar/Navbar'
import "./Dashboard.css"
import Footer from '../../Components/Footer/Footer'
import AdminInfoCard from '../../Components/AdminInfoCard/AdminInfoCard'
import { useSelector } from 'react-redux'
import UserInfoCard from '../../Components/UserInfoCard/UserInfoCard'

export default function Dashboard() {
  const {BookWormUser} = useSelector((state) => state)
  return (
    <>
      <div className='Dashboard' >
          <Navbar colorRight="#5f2c3e" colorLeft="#5f2c3e" color="white" />
          {
            BookWormUser.userInfo.admin === false  && <UserInfoCard />
          }
          {
            (BookWormUser.userInfo.superAdmin === true || BookWormUser.userInfo.admin === true) &&   <AdminInfoCard/>
          }
        </div>
        <Footer/>
    </>
)}
